module.exports = __webpack_public_path__ + "img/vacunas4.dc0e52d8.jpg";